import { useFlags } from 'launchdarkly-react-client-sdk';

export function useSubscriptionBundleFlag() {
	const { subscriptionBundleFlag } = useFlags();

	return { subscriptionBundleFlag };
}
